import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Flex from '@deprecated-ui/common/Flex';
import Button from '@deprecated-ui/watchlist/Button';
import { ButtonContainer, Input } from './styled';
import slice, { selectors, thunks } from './slice';
import rootSlice from '../slice';

const { actions } = slice;

function NewWatchlistForm() {
  const dispatch = useDispatch();
  const { isCollectionLoading } = useSelector(selectors);

  const [name, setName] = useState('');

  const createWatchlist = async (wlName) => {
    if (!wlName) {
      return;
    }

    const create = await dispatch(
      thunks.createCompanyWatchlist({ name: wlName }),
    );

    // @ts-ignore
    const data = create.payload?.data;

    if (data) {
      dispatch(
        rootSlice.actions.handleChangeActiveWatchlist({
          selected: data.watchlist_id,
          name: data.name,
        }),
      );

      dispatch(actions.handleSetDropdown({ isOpen: false }));
    }
  };

  const handleSaveClick = () => {
    createWatchlist(name);
  };

  const handleCancelClick = () => {
    dispatch(actions.handleSetFormOpen({ isOpen: false }));
  };

  const handleNameChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setName(e.target.value);
  };

  const handlePressEnter = (e) => {
    const val = e?.target?.value;

    createWatchlist(val);
  };

  return (
    <Flex direction="column" width="100%">
      <Input
        type="text"
        placeholder="Watchlist Name"
        value={name}
        onChange={handleNameChange}
        maxLength={25}
        autoFocus
        suffix={`${name.length}/25`}
        onPressEnter={handlePressEnter}
      />
      <ButtonContainer>
        <Button
          htmlType="button"
          onClick={handleCancelClick}
          loading={isCollectionLoading}
          block
        >
          Cancel
        </Button>
        <Button
          onClick={handleSaveClick}
          loading={isCollectionLoading}
          type="primary"
          block
        >
          Save
        </Button>
      </ButtonContainer>
    </Flex>
  );
}

export default NewWatchlistForm;
